import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "../../actions"
import {
    DisplayText,
    Stack,
    Button,
    TextStyle,
    Card,
    Toast,
    Icon,
    Modal,
    TextContainer,
} from "@shopify/polaris"
import "./styles.scss"
import formatDateTime from "../../utils/formatDateTime"
import Switch from "react-switch"
import Preloader from "../../components/WishlistApp/Preloader"
import { QuestionMarkMinor } from "@shopify/polaris-icons"
const INITIAL_STATE = {
    isLoading: false,
    toast: {
        show: false,
        content: "",
        error: false,
    },
    wishlist_settings_edited: [],
    compare_settings_edited: [],
    general_settings_edited: [],
    copied: {},
}

function mapStateToProps(state) {
    return {
        widgets: state.widgets,
        pages: state.pages,
        app_settings: state.app_settings,
        app_render: state.app_render,
        plan: state.plan,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}

class WidgetsManagement extends Component {
    constructor(props) {
        super(props)
    }

    state = {
        app_settings: JSON.parse(JSON.stringify(this.props.app_render)),
        isLoading: false,
        toast: {
            show: false,
            content: "",
            error: false,
        },
        wishlist_settings_edited: [],
        compare_settings_edited: [],
        general_settings_edited: [],
        copied: {},
        show: false,
    }

    componentDidMount() {
        const { actions, widgets } = this.props

        // clear widget selected
        // actions.changeWidgetSelectedAction({});

        // get youtube channel ids
    }

    checkWidget = () => {
        const { pages } = this.props
        let { widgets } = this.props
        if (window.parentUrl.includes("")) {
            widgets = [
                [
                    {
                        id: 0,
                        code: `{% render 'arn_wl_cp_buttons', type: 'wl_show_btn', product_handle: product.handle %}`,
                        updated_at: 1603274589479,
                        enabled: true,
                        name: "Show Wishlist Button",
                        saveState: false,
                    },
                    {
                        id: 1,
                        code: `{% if shop.metafields.arena.wl_cp_settings.wishlist_settings.launch_add.check_add_variant == true or shop.metafields.arena.wl_cp_settings.value.wishlist_settings.launch_add.check_add_variant == true %}
                          {% render 'arn_wl_cp_buttons', type: 'wl_add_btn', product_handle: product.selected_or_first_available_variant.id %}
                            {% else %}
                        {% render 'arn_wl_cp_buttons', type: 'wl_add_btn', product_handle: product.handle %}
                         {% endif %}
              `,
                        updated_at: 1603274589479,
                        enabled: true,
                        name: "Add to Wishlist Button",
                        saveState: false,
                    },
                    {
                        id: 2,
                        code: `{% if shop.metafields.arena.wl_cp_settings.wishlist_settings.launch_add.check_add_variant == true or shop.metafields.arena.wl_cp_settings.value.wishlist_settings.launch_add.check_add_variant == true %}
                          {% render 'arn_wl_cp_buttons', type: 'wl_add_btn', product_handle: product.selected_or_first_available_variant.id %}
                            {% else %}
                        {% render 'arn_wl_cp_buttons', type: 'wl_add_btn', product_handle: product.handle %}
                         {% endif %}
              `,
                        updated_at: 1603274589479,
                        enabled: true,
                        name: "Add to Wishlist Button on Product Page",
                        saveState: false,
                    },
                    {
                        id: 3,
                        code: `{% render 'arn_wl_cp_buttons', type: 'wl_remove-btn', product_handle: product.handle %}`,
                        updated_at: 1603274589479,
                        enabled: true,
                        name: "Remove Wishlist Button",
                        saveState: false,
                    },
                ],
                [
                    {
                        id: 0,
                        code: `{% render 'arn_wl_cp_buttons', type: 'cp_show_btn', product_handle: product.handle %}`,
                        updated_at: 1603274589479,
                        enabled: true,
                        name: "Show Compare Button",
                        saveState: false,
                    },
                    {
                        id: 1,
                        code: `{% render 'arn_wl_cp_buttons', type: 'cp_add_btn', product_handle: product.handle %}`,
                        updated_at: 1603274589479,
                        enabled: true,
                        name: "Add to Compare Button",
                        saveState: false,
                    },
                    {
                        id: 2,
                        code: `{% render 'arn_wl_cp_buttons', type: 'cp_add_btn', product_handle: product.handle %}`,
                        updated_at: 1603274589479,
                        enabled: true,
                        name: "Add to Compare Button on Product Page",
                        saveState: false,
                    },
                    {
                        id: 3,
                        code: `{% render 'arn_wl_cp_buttons', type: 'cp_remove_btn', product_handle: product.handle %}`,
                        updated_at: 1603274589479,
                        enabled: true,
                        name: "Remove Compare Button",
                        saveState: false,
                    },
                ],
                [
                    {
                        id: 0,
                        updated_at: 1603274589479,
                        enabled: true,
                        name: "Configure back in stock alert",
                        saveState: false,
                    },
                ],
                [
                    {
                        id: 0,
                        updated_at: 1603274589479,
                        enabled: true,
                        name: "Configure reminder email",
                        saveState: false,
                    },
                ],
            ]
        }
        switch (pages.selected) {
            case 1:
                widgets = widgets[0]
                break
            case 2:
                widgets = widgets[1]
                break
            default:
                widgets = widgets[0]
                break
        }
        return widgets
    }

    /**
     * Cache edited setting
     */
    cacheSetting(type: String, editObj: Object) {
        const settingKey =
            type === "wishlist"
                ? "wishlist_settings"
                : type === "compare"
                ? "compare_settings"
                : "general_settings"
        const editObjKey = Object.keys(editObj)[0]
        const editObjVal = Object.values(editObj)[0]
        const { app_settings, actions } = this.props
        const { wishlist_settings_edited, compare_settings_edited, general_settings_edited } =
            this.state
        const handleList =
            type === "wishlist"
                ? wishlist_settings_edited
                : type === "compare"
                ? compare_settings_edited
                : general_settings_edited
        const handleKey =
            type === "wishlist"
                ? "wishlist_settings_edited"
                : type === "compare"
                ? "compare_settings_edited"
                : "general_settings_edited"
        const propObjVal = app_settings[settingKey][editObjKey]
        let compareFlag = false
        if (!Array.isArray(editObjVal)) {
            // Normal value
            if (typeof editObjVal !== "object") {
                if (editObjVal === propObjVal) {
                    compareFlag = true
                }
            }
            // Object value
            else {
                if (
                    JSON.stringify({
                        ...this.state.app_settings[settingKey][editObjKey],
                        ...editObjVal,
                    }) === JSON.stringify(propObjVal)
                ) {
                    compareFlag = true
                }
            }
        } else {
            editObjVal.sort()
            propObjVal.sort()
            if (editObjVal.join() === propObjVal.join()) {
                compareFlag = true
            }
        }

        let newList = []
        let checkItemExisted = handleList.findIndex((item) => {
            let itemKey = Object.keys(item)[0]
            return itemKey === editObjKey
        })

        if (!compareFlag) {
            if (checkItemExisted !== -1) {
                newList = handleList.map((item) => {
                    let itemKey = Object.keys(item)[0]
                    if (itemKey === editObjKey) {
                        if (typeof editObjVal === "object" && !Array.isArray(editObjVal)) {
                            return {
                                [editObjKey]: {
                                    ...this.state.app_settings[settingKey][editObjKey],
                                    ...editObjVal,
                                },
                            }
                        } else {
                            return editObj
                        }
                    } else {
                        return item
                    }
                })
            } else {
                if (typeof editObjVal === "object" && !Array.isArray(editObjVal)) {
                    newList = handleList.concat([
                        {
                            [editObjKey]: {
                                ...this.state.app_settings[settingKey][editObjKey],
                                ...editObjVal,
                            },
                        },
                    ])
                } else {
                    newList = handleList.concat([editObj])
                }
            }
        } else {
            newList = handleList.filter((item) => {
                let itemKey = Object.keys(item)[0]
                return itemKey !== editObjKey
            })
        }

        this.setState({
            [handleKey]: newList,
        })
        actions.changeAppEditedAction(handleKey, newList)
        this.changeSetting()
    }

    changeSetting() {
        const { actions, pages } = this.props
        setTimeout(() => {
            if (pages.selected == 1)
                actions.changeAppRenderAction("wishlist", this.state.app_settings.wishlist_settings)
            else actions.changeAppRenderAction("compare", this.state.app_settings.compare_settings)
        }, 0)
    }

    handleSwitchShowButton = (val) => {
        const { pages } = this.props
        console.log(val)
        const { app_settings } = this.state
        let newWidget = Object.assign({}, app_settings)
        const { launch_show } =
            pages.selected == 1 ? newWidget.wishlist_settings : newWidget.compare_settings
        const type = "launch_show"
        const setting_type = pages.selected == 1 ? "wishlist" : "compare"
        val ? (launch_show.type = ["floating"]) : (launch_show.type = ["header"])
        this.setState({ app_settings: newWidget })
        this.cacheSetting(setting_type, {
            [type]: {
                ...launch_show,
            },
        })
    }

    handleSwitchAddButton = (val, index) => {
        const { pages } = this.props
        console.log(val)
        const { app_settings } = this.state
        let newWidget = Object.assign({}, app_settings)
        if (index == 1) {
            const { launch_add } =
                pages.selected == 1 ? newWidget.wishlist_settings : newWidget.compare_settings
            const type = "launch_add"
            const setting_type = pages.selected == 1 ? "wishlist" : "compare"
            val
                ? (launch_add.auto_insert_add_button = true)
                : (launch_add.auto_insert_add_button = false)
            this.setState({ app_settings: newWidget })
            this.cacheSetting(setting_type, {
                [type]: {
                    ...launch_add,
                },
            })
        } else {
            const { launch_add_product_page } =
                pages.selected == 1 ? newWidget.wishlist_settings : newWidget.compare_settings
            const type = "launch_add_product_page"
            const setting_type = pages.selected == 1 ? "wishlist" : "compare"
            val
                ? (launch_add_product_page.auto_insert_add_button = true)
                : (launch_add_product_page.auto_insert_add_button = false)
            this.setState({ app_settings: newWidget })
            this.cacheSetting(setting_type, {
                [type]: {
                    ...launch_add_product_page,
                },
            })
        }
    }

    /**
     * Change Enable setting function
     */
    enableSettings(type: String) {
        if (type === "wishlist") {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    wishlist_settings: {
                        ...this.state.app_settings.wishlist_settings,
                        wishlist_enable: !this.state.app_settings.wishlist_settings.wishlist_enable,
                    },
                },
            })
            setTimeout(() => {
                // Cache edited setting
                this.cacheSetting("wishlist", {
                    wishlist_enable: this.state.app_settings.wishlist_settings.wishlist_enable,
                })
            }, 0)
        } else {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    compare_settings: {
                        ...this.state.app_settings.compare_settings,
                        compare_enable: !this.state.app_settings.compare_settings.compare_enable,
                    },
                },
            })
            // Cache edited setting
            setTimeout(() => {
                this.cacheSetting("compare", {
                    compare_enable: this.state.app_settings.compare_settings.compare_enable,
                })
            })
        }
    }
    handleCopy = async (item) => {
        const text = item.code

        const el = document.createElement("textarea")
        el.value = text
        document.body.appendChild(el)
        el.select()
        document.execCommand("copy")
        document.body.removeChild(el)

        this.setState({ copied: item }, () =>
            setTimeout(() => {
                this.setState({ copied: {} })
            }, 2000),
        )
    }

    renderTableBody = () => {
        const { yout_app, actions, redirectToPage, pages } = this.props
        const { wishlist_settings, compare_settings } = this.state.app_settings
        const type = pages.selected == 1 ? wishlist_settings : compare_settings
        const widgets = this.checkWidget()
        const { copied } = this.state
        const link_help1 =
            "https://support.arenacommerce.com/support/solutions/articles/6000243479-how-to-modify-the-wishlist-compare-buttons#1---Wishlist-button"
        const link_help2 = "https://support.arenacommerce.com/support/solutions/folders/6000238959"
        const link_help3 =
            "https://support.arenacommerce.com/support/solutions/articles/6000243479-how-to-modify-the-wishlist-compare-buttons#3---Remove-button"
        let checked = false
        if (window.parentUrl.includes("")) {
            checked = true
        }
        return (
            <tbody>
                {JSON.parse(JSON.stringify(widgets)).map((item, index) => (
                    <tr key={item.id}>
                        <td>
                            <div className="btn-title">
                                <div
                                    className="item-title"
                                    onClick={async () => {
                                        await actions.changeWidgetSelectedAction(item)
                                        redirectToPage("WidgetsSetting")
                                    }}
                                >
                                    {item.name}
                                </div>
                            </div>
                        </td>
                        <td>
                            <div className="btn-title">
                                <a
                                    className="tooltip"
                                    target="_blank"
                                    href={
                                        index == 0
                                            ? link_help1
                                            : index == 1
                                            ? link_help2
                                            : link_help3
                                    }
                                >
                                    <Icon source={QuestionMarkMinor} color="subdued" />
                                    <span className="tooltiptext">How to work</span>
                                </a>
                            </div>
                        </td>
                        <td style={{ width: "50%" }}>
                            <div
                                className="clipboard-content noselect"
                                onClick={() => this.handleCopy(item)}
                            >
                                {Object.keys(copied).length > 0 && copied.id === item.id && (
                                    <div className="yta-tooltip">Copied !</div>
                                )}
                                <div>{item.code}</div>
                                <div className="yta-tooltip-help">Click to copy</div>
                            </div>
                        </td>
                        <td>
                            <div className="item-text updated-at">
                                {index == 0 ? (
                                    <Switch
                                        height={20}
                                        width={46}
                                        onChange={(val) => this.handleSwitchShowButton(val)}
                                        checked={type.launch_show.type == "floating" ? true : false}
                                    />
                                ) : checked && index == 2 ? (
                                    <Switch
                                        height={20}
                                        width={46}
                                        onChange={(val) => this.handleSwitchAddButton(val, index)}
                                        checked={
                                            type.launch_add_product_page.auto_insert_add_button
                                        }
                                    />
                                ) : !checked && index == 1 ? (
                                    <Switch
                                        height={20}
                                        width={46}
                                        onChange={(val) => this.handleSwitchAddButton(val, index)}
                                        checked={type.launch_add.auto_insert_add_button}
                                    />
                                ) : (
                                    <div style={{ textAlign: "center", fontSize: "4rem" }}>-</div>
                                )}
                            </div>
                        </td>
                        <td>
                            <div className="btn-icon-group">
                                <div
                                    className="btn-icon"
                                    onClick={async () => {
                                        await actions.changeWidgetSelectedAction(item)
                                        redirectToPage("WidgetsSetting")
                                    }}
                                >
                                    <div className="icon icon-edit" />
                                    <div>Edit</div>
                                </div>
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        )
    }

    enableAddVariant = () => {
        if (this.props.plan.plan != "free") {
            const { app_settings } = this.state
            const { launch_add } = app_settings.wishlist_settings
            const setting_type = "wishlist"
            let newWidget = Object.assign({}, app_settings)
            launch_add.check_add_variant = !launch_add.check_add_variant
            this.setState({ app_settings: newWidget, show: false })
            this.cacheSetting(setting_type, {
                ["launch_add"]: {
                    ...launch_add,
                },
            })
        }
    }

    handleClose() {
        this.setState({ show: false })
    }

    handleShow() {
        if (this.props.plan.plan != "free") {
            this.setState({ show: true })
        }
    }

    handleChangeMultipleProduct() {
        if (this.props.plan.plan != "free") {
            const { app_settings } = this.state
            let newWidget = Object.assign({}, app_settings)
            newWidget.wishlist_settings.allow_multiple = !newWidget.wishlist_settings.allow_multiple
            this.setState({ app_settings: newWidget })
            this.cacheSetting("wishlist", {
                allow_multiple: newWidget.wishlist_settings.allow_multiple,
            })
        }
    }

    renderWidgetsManagement = () => {
        const { actions, pages } = this.props
        const { show, app_settings } = this.state
        const { wishlist_settings, compare_settings } = app_settings
        const { launch_add } = pages.selected == 1 ? wishlist_settings : compare_settings

        return (
            <div className="widgets-management-body">
                {/* modal add variant */}
                <div>
                    <Modal
                        open={show}
                        onClose={() => this.handleClose()}
                        title={
                            <DisplayText>
                                <TextStyle variation="negative">Warning!!!</TextStyle>
                            </DisplayText>
                        }
                        primaryAction={{
                            content: "Accept",
                            onAction: () => this.enableAddVariant(),
                        }}
                        secondaryActions={[
                            {
                                content: "Close",
                                onAction: () => this.handleClose(),
                            },
                        ]}
                    >
                        <Modal.Section>
                            <TextContainer>
                                <div>
                                    <p>
                                        By switching from normal to product variant mode, all your
                                        current wishlist data will be removed to avoid code
                                        conflict. Please carefully consider before confirming.
                                    </p>
                                </div>
                            </TextContainer>
                        </Modal.Section>
                    </Modal>
                </div>
                {/* modal add variant */}

                <div className="title-block">
                    <Stack distribution="equalSpacing" alignment="center">
                        <Stack.Item fill>
                            <Stack alignment="center" spacing="extraLoose">
                                <div className="page-title">
                                    {pages.selected == 1 ? "Wishlist Settings" : "Compare Settings"}
                                </div>
                            </Stack>
                        </Stack.Item>
                        <Stack.Item>
                            {pages.selected == 1 ? (
                                <Stack alignment="center">
                                    <div
                                        onClick={() => this.enableSettings("wishlist")}
                                        className={`yta-custom yta-custom-${
                                            wishlist_settings.wishlist_enable
                                                ? "enabled"
                                                : "disabled"
                                        }`}
                                    >
                                        {wishlist_settings.wishlist_enable ? "Enabled" : "Disabled"}
                                    </div>
                                    <Switch
                                        height={20}
                                        width={46}
                                        onChange={() => this.enableSettings("wishlist")}
                                        checked={wishlist_settings.wishlist_enable}
                                    />
                                    {wishlist_settings.wishlist_enable && (
                                        <Stack alignment="center">
                                            <div className="add-mode">
                                                <Stack alignment="center">
                                                    <div
                                                        onClick={() => this.handleShow()}
                                                        className={`yta-custom yta-custom-${
                                                            launch_add.check_add_variant
                                                                ? "enabled"
                                                                : "disabled"
                                                        }`}
                                                    >
                                                        Variant Mode
                                                    </div>
                                                    <Switch
                                                        height={20}
                                                        width={46}
                                                        onChange={() => {
                                                            this.handleShow()
                                                        }}
                                                        disabled={
                                                            this.props.plan.plan == "free"
                                                                ? true
                                                                : false
                                                        }
                                                        checked={
                                                            this.props.plan.plan == "free"
                                                                ? false
                                                                : launch_add.check_add_variant
                                                        }
                                                    />
                                                    {this.props.plan.plan == "free" && (
                                                        <span className="tooltiptext">
                                                            Please upgrade your Plan to use this feature
                                                        </span>
                                                    )}
                                                </Stack>
                                            </div>

                                            <div className="add-mode">
                                                <Stack alignment="center">
                                                    <div
                                                        onClick={() =>
                                                            this.handleChangeMultipleProduct()
                                                        }
                                                        className={`yta-custom yta-custom-${
                                                            wishlist_settings.allow_multiple
                                                                ? "enabled"
                                                                : "disabled"
                                                        }`}
                                                    >
                                                        Multiple Wishlist
                                                    </div>
                                                    <Switch
                                                        height={20}
                                                        width={46}
                                                        onChange={() =>
                                                            this.handleChangeMultipleProduct()
                                                        }
                                                        disabled={
                                                            this.props.plan.plan == "free"
                                                                ? true
                                                                : false
                                                        }
                                                        checked={wishlist_settings.allow_multiple}
                                                    />
                                                    {this.props.plan.plan == "free" && (
                                                        <span className="tooltiptext">
                                                            Please upgrade your Plan to use this feature
                                                        </span>
                                                    )}
                                                </Stack>
                                            </div>
                                        </Stack>
                                    )}
                                </Stack>
                            ) : (
                                <Stack alignment="center">
                                    <div
                                        onClick={() => this.enableSettings("compare")}
                                        className={`yta-custom yta-custom-${
                                            compare_settings.compare_enable ? "enabled" : "disabled"
                                        }`}
                                    >
                                        {compare_settings.compare_enable ? "Enabled" : "Disabled"}
                                    </div>
                                    <Switch
                                        height={20}
                                        width={46}
                                        onChange={() => this.enableSettings("compare")}
                                        checked={compare_settings.compare_enable}
                                    />
                                </Stack>
                            )}
                        </Stack.Item>
                    </Stack>
                </div>

                <div className="subtitle-block">
                    <div className="page-text">
                        {pages.selected == 1
                            ? "Configure the general Wishlist settings that will be reflected across your store."
                            : "Configure the general Compare settings that will be reflected across your store."}
                    </div>
                </div>

                <div className="table-block-body">
                    <table>
                        <thead className="">
                            <tr>
                                <th>NAME</th>
                                <th></th>
                                <th>
                                    INSERT CODE MANUAL (CLICK TO COPY) or {"  "}
                                    <a
                                        href="https://support.arenacommerce.com/support/tickets/new"
                                        target="_blank"
                                    >
                                         {"  "} Request a free installation
                                    </a>
                                </th>
                                <th>ACTIVE</th>
                                <th>ACTIONS</th>
                                {/* <th>ENABLED</th> */}
                            </tr>
                        </thead>

                        {this.renderTableBody()}
                    </table>
                </div>
            </div>
        )
    }

    render() {
        const { yout_app, widgets } = this.props
        const { toast, widgetDeleted, isLoading, refreshYT, ytChannelsOptions } = this.state
        return (
            <div className="yta-widgets-management">
                {this.renderWidgetsManagement()}
                {isLoading && <Preloader />}

                {toast.show && (
                    <Toast
                        content={toast.content}
                        error={toast.error}
                        onDismiss={() =>
                            this.setState({
                                toast: { show: false, content: "", error: false },
                            })
                        }
                    />
                )}
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WidgetsManagement)
